/**
 * Calendar YYYY-MM-DD strings in Asia/Kolkata (IST), matching server-side commission filters.
 */

const tz = "Asia/Kolkata";

function partsToYmd(parts) {
  const y = parts.find((p) => p.type === "year")?.value;
  const mo = parts.find((p) => p.type === "month")?.value;
  const d = parts.find((p) => p.type === "day")?.value;
  if (!y || !mo || !d) return null;
  return `${y}-${mo}-${d}`;
}

export function getISTTodayYmd() {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: tz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  return partsToYmd(parts) || new Date().toISOString().split("T")[0];
}

export function getISTFirstOfMonthYmd() {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: tz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  const y = parts.find((p) => p.type === "year")?.value;
  const mo = parts.find((p) => p.type === "month")?.value;
  if (!y || !mo) {
    const n = new Date();
    return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-01`;
  }
  return `${y}-${mo}-01`;
}
